// extracted by mini-css-extract-plugin
module.exports = {"tablist":"src-components-Tab-styles___tablist","tabsWrapper":"src-components-Tab-styles___tabsWrapper"};